import { styled } from "@mui/material";

import Slider from "@mui/material/Slider";

export const CustomSliderRoot = styled(Slider)(({ theme }) => ({
  color: theme?.palette?.companyColors?.accent,
  height: 3,
  padding: "13px 0",
  marginTop: 17,
  marginLeft: 15,
  "& .MuiSlider-thumb": {
    height: 27,
    width: 27,
    backgroundColor: theme?.palette?.companyColors?.accent,
    // border: `1px solid ${theme?.palette?.companyColors?.secondary}`,
    "&:hover": {
      boxShadow: "0 0 5px 0 rgba(58, 133, 137, 0.5)",
    },
    "& .thumb-bar": {
      height: 9,
      width: 1,
      backgroundColor: theme?.palette?.companyColors?.secondary,
      marginLeft: 1,
      marginRight: 1,
    },
  },
  "& .MuiSlider-track": {
    height: 5,
  },
  "& .MuiSlider-rail": {
    color: theme?.palette?.companyColors?.secondary,
    opacity: 1,
    height: 7,
    ...theme.applyStyles("dark", {
      color: "#bfbfbf",
      opacity: undefined,
    }),
  },
  "& .MuiSlider-mark": {
    color: theme?.palette?.companyColors?.neutral,
  },
  "& .MuiSlider-valueLabel": {
    color: theme?.palette?.companyColors?.secondary,
    background: theme?.palette?.companyColors?.neutral,
    boxShadow: "0 0 5px 0px rgba(58, 133, 137, 0.5)",
    span: {
      padding: "2px 2px 0",
      fontSize: "0.9rem",
    },
  },
  // "& .MuiSlider-markLabel": {
  //   transform: "rotate(-45deg)",
  // },
}));
